import { timelineStages } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-20 border-b border-background-300/70 bg-background-100">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="TIMELINE"
          title="舆论发酵时间轴：从被截取传播到当下"
          desc="把话题从起点到当下的关键节点按顺序排好，回看时不容易被单张截图带偏，也更容易判断下一步往哪走。"
          aside={
            <span className="inline-flex items-center gap-1.5 rounded-md border border-accent-300 bg-accent-100 px-3 py-1.5 font-label text-xs text-accent-900">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-history-line text-xs"></i>
              </span>
              6 个关键节点
            </span>
          }
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {timelineStages.map((stage, index) => {
            const isNow = stage.tag === "当下";
            return (
              <div
                key={stage.time}
                className={`relative overflow-hidden rounded-lg border p-4 md:p-5 ${
                  isNow
                    ? "border-accent-400 bg-accent-50"
                    : "border-background-300/70 bg-background-50"
                }`}
              >
                <span
                  className={`absolute inset-x-0 top-0 h-1 ${
                    isNow ? "bg-accent-500" : "bg-secondary-300"
                  }`}
                />
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2">
                    <span
                      className={`flex h-6 w-6 items-center justify-center rounded-full font-label text-xs font-bold ${
                        isNow
                          ? "bg-accent-500 text-accent-950"
                          : "bg-secondary-200 text-secondary-900"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="font-label text-xs text-foreground-500">{stage.time}</span>
                  </span>
                  <span
                    className={`rounded px-2 py-0.5 font-label text-xs ${
                      isNow ? "bg-accent-200 text-accent-900" : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    {stage.tag}
                  </span>
                </div>
                <h4 className="mt-3 font-heading text-base font-bold text-foreground-950">{stage.title}</h4>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{stage.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}